<div class="flex items-center gap-2 min-w-0 me-4">
  <span
    [class.truncate]="!wrap()"
    [class.wrap-break-word]="wrap()"
    [attr.title]="translations() | translateDirectus"
  >
    {{ translations() | translateDirectus }}
  </span>
  @if (translations() | translateDirectus; as description) {
    <app-directus-tooltip [tooltip]="translations() | translateDirectus: 'description'" />
  }
</div>
